export const homeSchema = {
    '@context': 'https://schema.org',
    '@type': ['SoftwareApplication', 'WebPage'],
    name: 'Elumity',
    url: 'https://elumity.com/',
    description:
        'Discover Elumity, the all-in-one academic software for organizing, managing, and sharing knowledge. Boost productivity with seamless workflows today!',
    applicationCategory: 'ProductivityApplication',
    operatingSystem: 'Windows, MacOS, Linux, iOS, Android',
    softwareVersion: '1.0',
    creator: {
        '@type': 'Organization',
        name: 'Elumity',
        url: 'https://elumity.com'
    },
    organization: {
        '@type': 'Organization',
        name: 'Elumity',
        url: 'https://elumity.com',
        logo: 'https://elumity.com/logo.png',
        sameAs: ['https://www.linkedin.com/company/elumity', 'https://www.twitter.com/elumityapp']
    },
    mainEntity: {
        '@type': 'WebPage',
        name: 'Elumity - All-in-One Academic Software',
        url: 'https://elumity.com/'
    }
};
